import React, { useState } from "react";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import FilterIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";
import "../../../../../styles/Pages/Financial/CashInFlow/Fees/CollectFeesBox.style.css";

const CollectFeesBox = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleFilterChange = (value) => {
    setSelectedFilters((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  return (
    <div className="CollectFeesContainer mt-2">
      <div className="CollectFeesHeader">
        <h4>Collect fees</h4>
      </div>
      <div className="CollectFeesInputContainer">
        <div className="searchInputContainer">
          <button className="searchBtn">
            <img src={SearchIcon} alt="Search" />
          </button>
          <input
            type="text"
            className="pageHeaderInput"
            placeholder="Search id"
          />
        </div>
        <span className="color-grayColor">Or</span>
        <div className="searchInputContainer">
          <button className="searchBtn">
            <img src={SearchIcon} alt="Search" />
          </button>
          <input
            type="text"
            className="pageHeaderInput"
            placeholder="Search name"
          />
        </div>
        <div className="staffsFilterSearchButtonContainer">
          <button onClick={() => setShowFilter(!showFilter)}>
            <img src={FilterIcon} alt="Filter icon" />
            <span className="filterText">& class</span>
          </button>
          {showFilter && (
            <ul className="filterDropdown">
              {["Security", "Manager", "Super"].map((role) => (
                <li key={role}>
                  <input
                    type="checkbox"
                    value={role}
                    checked={selectedFilters.includes(role)}
                    onChange={() => handleFilterChange(role)}
                  />
                  <span>{role}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollectFeesBox;
